/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import {
	TextInput as NativeTextInput,
	TextInputProps,
} from '@mantine/core';

// I18n
import { useTranslation } from 'react-i18next';

// Style
import classes from './TextInputV2.module.css';

// Icons
import { IconExclamationCircle } from '@tabler/icons-react';

/* -------------------------------------------------------------------------- */
/*                                  Component                                 */
/* -------------------------------------------------------------------------- */
export const TextInputV2 = (props: TextInputProps) => {
	const { t } = useTranslation();
	const { error, ...restProps } = props;
	/* ******************************** RENDERING ******************************* */
	return (
		<NativeTextInput
			error={t(error ? String(error) : '')}
			withErrorStyles={true}
			rightSectionPointerEvents="none"
			autoComplete="new-password"
			rightSection={
				error && (
					<IconExclamationCircle
						className={classes.errorIcon}
						color="var(--mantine-color-error)"
					/>
				)
			}
			classNames={{
				input: !error
					? classes.input
					: classes.inputError,
				error: classes.error,
				label: classes.label,
			}}
			{...restProps}
		/>
	);
};
